<template>
  <error-layout class="page-error-500"
                :img="require('@/assets/img/error/500.png')"
                desc="服务器正在升级"
  ></error-layout>
</template>

<script>
  import ErrorLayout from '@/layout/ErrorLayout';

  export default {
    name: 'PageError500',
    components: {
      ErrorLayout,
    },
  };
</script>
